import { Button, Modal, ModalBody } from 'reactstrap'
import DateRangeAndGuests from 'Checkout/Components/Shared/CartSummary/DateRangeAndGuests'
import FontAwesomeIcon from 'Shared/FontAwesomeIcon/FontAwesomeIcon'

const ConfirmRemoveModal = ({ isOpen, onConfirm, placeName, reservation, toggle }) => (
  <Modal centered className="confirm-remove-modal" isOpen={isOpen} toggle={toggle}>
    <ModalBody>
      <p className="mt-2">Are you sure you want to remove this reservation?</p>

      <p>{placeName}</p>

      <DateRangeAndGuests reservation={reservation} />

      <div className="d-flex justify-content-between mt-4">
        <Button color="outline-dark-blue" className="me-3" onClick={toggle}>No, Go Back</Button>

        <Button color="danger" onClick={onConfirm}>
          <FontAwesomeIcon className="me-2" icon={['far', 'trash-can']} />

          Remove
        </Button>
      </div>
    </ModalBody>
  </Modal>
)

export default ConfirmRemoveModal
